<template>
  <section class="content epos-box">
    <div class="box box-info">
      <div class="">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-lg-6 posItm lg-flex-order-2">
            <DataView :value="displayItemList" :paginator="true" :rows="9" :layout="layout" :rowsPerPageOptions="[9,100,200]">
              <template #header>
                <div class="p-grid p-nogutter">
                  <div class="p-field p-col-12 radiobox">
                    <div class="radiobox-itm">
                      <RadioButton id="barcode" name="Barcode" value="Barcode" v-model="searchByBarcode"
                      @change="focusOnPageLoad"/>
                      <label for="barcode" class="p-mr-3">Barcode</label>
                    </div>
                    <div class="radiobox-itm">
                      <RadioButton id="search" name="Search" value="Search" v-model="searchByBarcode"
                                   @change="focusOnPageLoad"/>
                      <label for="search">Name</label>
                    </div>
                    <div class="radiobox-itm">
                      <RadioButton id="code" name="Item Code" value="Code" v-model="searchByBarcode"
                                   @change="focusOnPageLoad"/>
                      <label for="code">Code</label>
                    </div>
                  </div>
                  <InputText v-model="searchTerm" v-show="searchByBarcode==='Search'" placeholder="Please enter keyword"
                             ref="search" @input="searchItemWithUserInput"/>
                  <InputText v-model="searchTerm" v-show="searchByBarcode === 'Barcode'"
                             @keypress.enter="searchItem($event)" ref=barcode placeholder="Barcode"/>
                  <InputText v-model="searchTerm" v-show="searchByBarcode==='Code'" placeholder="Please enter keyword"
                             ref="code" @input="searchItemWithUserInput"/>
                </div>
              </template>
              <template #grid="slotProps">
                <div class="grid-item-col">
                  <div class="product-grid-item card">
                    <div class="product-grid-item-top">
                      <div>
                        <i class="pi pi-tag product-category-icon"></i>
                        <span class="product-category">{{ slotProps.data.itemCode }}</span>
                      </div>
                    </div>
                    <div class="product-grid-item-content">
                      <a href="" @click.prevent="displaySize(slotProps.data)">
                        <img :src="slotProps.data.singleImageUrl" :alt="slotProps.data.name"/></a>
                      <div class="product-name">{{ slotProps.data.name }}</div>
                    </div>
                    <div class="product-grid-item-bottom">
                      <span class="product-price">{{ slotProps.data.closingStock }}</span>

                      <Button class="p-button p-component p-button-icon-only" icon="pi pi-shopping-cart"
                              @click.prevent="displaySize(slotProps.data)">
                      </Button>
                    </div>
                  </div>
                </div>
              </template>
            </DataView>
          </div>
          <div class="p-field p-col-12 p-lg-6 posItm lg-flex-order-1">
            <DataTable :value="salesItemList" :paginator="true" :rows="25"
                       editMode="cell" class="editable-cells-table pos-table"
                       paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                       :rowsPerPageOptions="[25,50,100]"
                       currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
              <Column header="Item" field="itemName">
                <template #footer>
                  Total:
                </template>
                </Column>
              <Column header="Qty" field="quantity" bodyClass="pos-table-quantity">
                <template #body="slotProps">
                  <InputNumber onfocus="if (this.value === '0'){this.value = ''
}" v-model="slotProps.data[slotProps.column.field]" showButtons
                               buttonLayout="horizontal" style="width: 100%;" decrementButtonClass="p-button-danger"
                               incrementButtonClass="p-button-success" incrementButtonIcon="pi pi-plus"
                               decrementButtonIcon="pi pi-minus" :min="0" :max="100000"/>
                </template>
                <template #footer>
                  {{ totalQuantity.toFixed(2) }}
                </template>
              </Column>
              <Column header="Rate" field="sellingPrice" bodyClass="pos-table-rate">
                <template #body="slotProps">
                  <InputNumber v-if="enableRateEdit" onfocus="if (this.value === '0'){this.value = ''
}" v-model="slotProps.data.sellingPrice" :minFractionDigits="2"
                               :maxFracionDigits="4"/>

                  <InputNumber v-else disabled onfocus="if (this.value === '0'){this.value = ''
}" v-model="slotProps.data.sellingPrice" :minFractionDigits="2"
                               :maxFracionDigits="4"/>
                </template>

              </Column>
              <Column header="Total" bodyClass="pos-table-total">
                <template #body="slotProps">
                  {{ slotProps.data.sellingPrice * slotProps.data.quantity }}
                </template>
                <template #footer>
                  {{subTotal.toFixed(2) }}
                </template>
              </Column>
              <Column header="Action" bodyClass="pos-table-action">
                <template #body="slotProps">
                  <Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text"
                          @click="removeItemFromList(slotProps.index,slotProps)"/>
                </template>
              </Column>
            </DataTable>
            <div style="display:none">{{ findTotalQuantity }}{{ findDueAmt }}</div>
            <Card class="p-mt-3 p-mb-3">
              <template #content>
                <div class="invoice-box"><p class="invoice-ttl">Total Quantity:</p> <label class="">{{ totalQuantity }}</label></div>
                
                <div class="invoice-box">
                  <p class="invoice-ttl" style="font-weight: bold">Discount:</p>
                  <div class="invoice-col">
                    <div class="ivoice-btn">
                      <Button v-if="chooseDiscountAmt" @click="chooseDisountAmt" label="Rs"/>
                      <Button v-if="chooseDiscountPer" @click="chooseDisPercent" label="%"/>
                    </div>
  
                    <div class="invoice-input">
                      <InputNumber onfocus="if (this.value === '0'){this.value = ''
    }" v-if="chooseDiscountAmt" placeholder="Discount Amount"
                                   v-model="discountAmt"/>
                      <InputNumber onfocus="if (this.value === '0'){this.value = ''
    }" v-if="chooseDiscountPer" v-model="discountPer"
                                   placeholder="Discount Per"/>
                    </div>
                  </div>
                </div>
                
                <div class="invoice-box">
                  <p class="invoice-ttl" style="font-weight: bold">Discount Amt:</p><label class="">{{ 'Rs. ' + discountAmt }}</label>
                </div>
                <div class="invoice-box"><p class="invoice-ttl" style="font-weight: bold">Sub Total:</p><label class="">{{ 'Rs. ' + subTotal }}</label></div>

                
                <div class="invoice-box"><p class="invoice-ttl" style="font-weight: bold">Total:</p><label class="">{{ 'Rs. ' + totalBillAmount }}</label></div>
                
              </template>
            </Card>
            <div class="p-fluid p-formgrid p-grid">

              <div class="p-field p-col-12 p-md-4">
                <label style="font-weight: bold">Contact Number:</label>
                <InputText @change="findPosCustomer" v-model="contactNumber" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');" id="contactNum"/>
              </div>

              <div class="p-field p-col-12 p-md-4">
                <label style="font-weight: bold">Customer Name:</label>
                <InputText  v-model="customerName"/>
              </div>
              
              <div class="p-field p-col-12 p-md-4"> 
                <label style="font-weight: bold">E-mail:</label>
                <InputText  v-model="email" />
              </div>
              <!-- <div class="p-field p-col-12 p-md-12">

              </div> -->
              <div class="p-field p-col-12 p-md-6">
                <label style="font-weight: bold">Tender Amount:</label>
                <InputNumber onfocus="if (this.value === '0.00'){this.value = ''
}" mode="decimal" :minFractionDigits="2" v-model="tenderAmount"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <h4 v-if="dueAmount < 0">Return Amount: <b style="color:red;font-weight: bold">{{ 'Rs. ' + dueAmount }}</b></h4>
                <h4 v-if="dueAmount > 0">Return Amount: <b style="color:green;font-weight: bold">{{ 'Rs. ' + dueAmount }}</b></h4>
                <h4 v-if="dueAmount === 0">Return Amount: <b style="color:grey;font-weight: bold">{{ 'Rs. ' + dueAmount }}</b></h4>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="status1" style="font-weight: bold">Pay By:</label>
                <div class="radiobox">
                  <div class="radiobox-itm">
                    <RadioButton id="status1" name="Cash" value="CASH" v-model="paymentMethod"/>
                    <label for="status1" class="p-mr-3">Cash</label>
                  </div>
                  <div class="radiobox-itm">
                    <RadioButton id="status2" name="Esewa" value="ESEWA" v-model="paymentMethod"/>
                    <label for="status2">Esewa</label>
                  </div>
                  <div class="radiobox-itm">
                    <RadioButton id="status3" name="Fonepay" value="FONEPAY" v-model="paymentMethod"/>
                    <label for="status3">Fonepay</label>
                  </div>
                  <div class="radiobox-itm">
                    <RadioButton id="status4" name="Khalti" value="Khalti" v-model="paymentMethod"/>
                    <label for="status4">Khalti</label>
                  </div>
                  <div class="radiobox-itm">
                    <RadioButton id="status5" name="Bank" value="Bank" v-model="paymentMethod"/>
                    <label for="status5">Bank</label>
                  </div>
                  <div class="radiobox-itm">
                    <RadioButton id="status6" name="Ncm" value="Ncm" v-model="paymentMethod"/>
                    <label for="status6">Ncm</label>
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label style="font-weight: bold" for="status1">Paid Status:</label>
                <div class="radiobox">
                  <div class="radiobox-itm">
                    <RadioButton id="status1" name="paid" value="PAID" v-model="paymentStatus"/>
                    <label for="status1" class="p-mr-3">Paid</label>
                  </div>
                  <div class="radiobox-itm">
                    <RadioButton id="status2" name="unpaid" value="UNPAID" v-model="paymentStatus"/>
                    <label for="status2">Unpaid/Delivery</label>
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12 p-md-6" >
                <label for="address" style="font-weight: bold">Address:</label>
                <InputText v-model="address" id="address"/>
              </div>
              <div class="p-field p-col-12 p-md-6" v-if="paymentStatus==='UNPAID'">
                <label for="delivery" style="font-weight: bold">Delivery Amount:</label>
                <InputText v-model="deliveryCharge" id="delivery"/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="remarks" style="font-weight: bold">Remarks:</label>
                <InputText v-model="remarks" id="remarks"/>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-6 p-lg-4 p-xl-3">
                <Button label="Submit" @click.prevent="savePOSEntry"
                        class="p-button p-component p-button-success"/>
              </div>
              <div class="p-field p-col-6 p-lg-4 p-xl-3">
                <Button label="Cancel" class="p-button p-component p-button-danger" @click="$router.back()"/>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Dialog
      :visible.sync="printDialog"
      header="Do you want to print this bill?"
      :style="{width: '35vw'}"
      :modal="true"
      :closable="false"
    >
      <div class="p-fluid p-formgrid p-grid p-mt-2">
        <div class="p-field p-col-12 p-xl-2">
          <Button class="p-button-raised p-button-rounded" @click="printBill" label="Yes" icon="pi pi-check"/>
        </div>
        <!-- <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-rounded" @click="printQOT" label="QOT Yes" icon="pi pi-check"/>
        </div> -->
        <div class="p-field p-col-12 p-xl-2">
          <Button class="p-button-raised p-button-rounded p-button-danger" @click="closePrintDialog" icon="pi pi-times"
                  label="No"/>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible.sync="qotPrintDialog"
      header="Do you want to print this bill?"
      :style="{width: '35vw'}"
      :modal="true"
      :closable="false"
    >
      <div class="p-fluid p-formgrid p-grid p-mt-2">
        <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-rounded" @click="printQOT" label="Yes" icon="pi pi-check"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <Button class="p-button-raised p-button-rounded p-button-danger" @click.prevent="closePrintDialog" icon="pi pi-times"
                  label="No"/>
        </div>
      </div>
    </Dialog>
      <Dialog header="Size Details" :visible.sync="displayBasic"
                    :style="{width: '60vw', height:'20vw'}" :modal="true" :closable="true"
                    :contentStyle="{'overflow': 'visible'}">
                    <DataTable :value="inventorySizeDetailsDTOList" :paginator="true" :rows="5">
              <Column header="Size" field="size" bodyStyle="width:25%"/>
              <Column header="Color" field="color" bodyStyle="width:25%"/>
                <Column header="Avl Qty" field="quantity" bodyStyle="width:25%"/>
              <Column header="Qty" style="max-width: 100%;" field="salesQty" bodyStyle="width:50%">
                <template #body="slotProps">
                  <InputNumber onfocus="if (this.value === '0'){this.value = ''}" v-model="slotProps.data[slotProps.column.field]" showButtons
                               buttonLayout="horizontal" style="width: 3em;" decrementButtonClass="p-button-danger"
                               incrementButtonClass="p-button-success" incrementButtonIcon="pi pi-plus"
                               decrementButtonIcon="pi pi-minus" :min="0" :max="100000"/>
                </template>
              </Column>
             
              <!-- <Column header="Action">
                <template #body="slotProps">
                  <Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text"
                          @click="removeItemFromList(slotProps.index,slotProps)"/>
                </template>
              </Column> -->
            </DataTable>
<br/>
           <div style="float:right">
            <Button class="p-button-raised p-button-rounded p-button-success" label="Add"
                              @click.prevent="addItemToList(salesData)"/>
           </div>
   
            </Dialog>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DataView from 'primevue/dataview'
import Card from 'primevue/card'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import RadioButton from 'primevue/radiobutton'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Dialog from 'primevue/dialog'

export default {
  name: 'PointofSales',
  props: ['pos'],
  data() {
    return {
      itmQty: 1,
      displayBasic: false,
      salesData: null,
      displayItemList: [],
      salesItemList: [],
      posDetailDeleteList: [],
      inventorySizeDetailsDTOList: [],
      layout: 'grid',
      enableRateEdit: false,
      salesItem: {},
      paymentMethod: 'CASH',
      totalQuantity: 0,
      searchTerm: '',
      tenderAmount: 0,
      dueAmount: 0,
      loading: false,
      subTotal: 0,
      vat: 13,
      totalBillAmount: 0,
      customerName: '',
      contactNumber: 0,
      email: '',
      chooseDiscountPer: false,
      chooseDiscountAmt: true,
      discountPer: 0,
      discountAmt: 0,
      // searchByBarcode: 'Search',
      printDialog: false,
      qotPrintDialog: false,
      dataToPrint: {},
      paymentStatus: 'PAID',
      address: '',
      inMemoryList: null,
      deliveryCharge: 0,
      remarks: '',
      edit: false,
      posSalesId: null
    }
  },
  mounted() {
    this.itemsList()
    this.checkEditRate()
    this.checkSearchType()
    if (this.$store.getters.modules.includes('5.41')) {
      this.searchByBarcode = 'Barcode'
    } else {
      this.searchByBarcode = 'Search'
    }
    console.log('module' + this.$store.getters.modules)
    console.log('mounted' + this.searchByBarcode)
    if (this.pos !== undefined) {
      this.editPOS()
    }
  },
  computed: {
    findTotalQuantity() {
      this.totalQuantity = 0
      this.subTotal = 0
      if (this.salesItemList.length > 0) {
        for (let i = 0; i < this.salesItemList.length; i++) {
          this.totalQuantity += parseFloat(this.salesItemList[i].quantity)
          if (this.salesItemList[i].quantity !== null) {
            this.subTotal += parseFloat(this.salesItemList[i].sellingPrice) * parseFloat(this.salesItemList[i].quantity)
          }
          if (isNaN(this.discountAmt)) {
            this.discountAmt = 0
          }
          if (this.chooseDiscountPer === true) {
            if (this.discountPer > 100) {
              this.$toast.add({
                severity: 'error',
                summary: '',
                detail: 'Discount must be less than 100 %',
                life: 10000
              })
              return
            }
            if (this.discountAmt === '') {
              this.discountAmt = 0
            }
            this.discountAmt = (parseFloat(this.subTotal) * this.discountPer / 100)
            // this.discountPer = (parseFloat(this.discountAmt) / parseFloat(this.subTotal)) * 100
          }
          this.totalBillAmount = parseFloat(this.subTotal) - parseFloat(this.discountAmt)
          if (isNaN(this.totalQuantity)) {
            this.totalQuantity = 0
          }
          if (isNaN(this.totalBillAmount)) {
            this.totalBillAmount = this.subTotal
          }
        }
        if (this.chooseDiscountAmt === true) {
          if (this.discountAmt > this.subTotal) {
            // // debugger
            this.$toast.add({
              severity: 'error',
              summary: '',
              detail: 'Discount Amount must be less than total Amount!',
              life: 10000
            })
            return
          }
          // // debugger
          if (this.discountAmt === null) {
            this.discountAmt = 0
          }
          if (isNaN(this.discountAmt)) {
            this.discountAmt = 0
          }
          // this.discountAmt = (parseFloat(this.subTotal) * this.discountPer / 100)
        }
      }
    },
    findDueAmt() {
      if (this.tenderAmount == null) {
        this.tenderAmount = 0
      }
      if (this.tenderAmount >= 0) {
        this.dueAmount = parseFloat(this.tenderAmount) - parseFloat(this.totalBillAmount)
      }
    }
  },
  methods: {
    async itemsList() {
      let response = await this.$store.dispatch('loadItemMasterListByItemTypeAndAvailable')
      this.displayItemList = response.data.data
      this.inMemoryList = response.data.data
      this.focusOnPageLoad()
    },
    async findPosCustomer() {
      let response = await this.$store.dispatch('posCustomerByContactNumber', this.contactNumber)
      if (response.length > 0) {
        this.customerName = response[0].customerName
        this.email = response[0].email
        this.address = response[0].address
      }
    },
    displaySize(data) {
      this.salesData = data
      this.inventorySizeDetailsDTOList = data.inventorySizeDetailsDTOList
      if (this.inventorySizeDetailsDTOList.length === 0) {
        this.addItemToList(data)
      } else {
        this.displayBasic = true
      }
    },
    addItemToList(data) {
      if (this.$store.getters.modules.includes('5.41')) {
        this.searchByBarcode = 'Barcode'
      } else {
        this.searchByBarcode = 'Search'
      }
      if (data !== undefined) {
        if (data.quantity === undefined) {
          data.quantity = this.itmQty
        }
        let item = {
          itemId: data.id,
          itemName: data.name,
          sellingPrice: data.salesRate,
          quantity: data.quantity,
          vatType: data.vatType,
          inventorySizeDetailsDTOList: this.inventorySizeDetailsDTOList
        }
        if (this.salesItemList.length > 0) {
          let found = this.salesItemList.find(obj => obj.itemId === data.id)
          if (found === undefined) {
            this.salesItemList.push(item)
          } else {
            if (found.itemId === data.id) {
              // console.log('gere')
              if (data.closingStock <= found.quantity) {
                this.$toast.add({
                  severity: 'error',
                  summary: '',
                  detail: 'Stock not available!',
                  life: 10000
                })
                return
              } else {
                found.quantity = found.quantity + 1
              }
            }
          }
        } else {
          this.salesItemList.push(item)
        }
      }
      this.displayBasic = false
      this.focusOnPageLoad()
    },
    removeItemFromList(index, data) {
      this.salesItemList.splice(data.index, 1)
      // debugger
      // this.searchByBarcode = 'Search'
      if (this.$store.getters.modules.includes('5.41')) {
        this.searchByBarcode = 'Barcode'
      } else {
        this.searchByBarcode = 'Search'
      }
      if (this.salesItemList.length === 0) {
        this.displayItemList = this.inMemoryList
        this.reset()
      }
      if (this.edit && data.data.id !== null) {
        this.posDetailDeleteList.push({...data.data})
      }
      this.focusOnPageLoad()
    },
    searchItem(event) {
      if (this.searchByBarcode === 'Barcode') {
        this.displayItemList = this.displayItemList.filter(item => {
          return item.fullQrCode.includes(this.searchTerm)
        })
        this.salesItem = this.displayItemList[0]
        if (this.salesItem === undefined) {
          this.searchTerm = ''
          this.itemsList()
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'No item available!',
            life: 10000
          })
          return
        }
        if (event.code === 'Enter') {
          this.addItemToList(this.salesItem)
        }
        this.searchTerm = ''
        if (this.searchTerm === '') {
          this.displayItemList = this.inMemoryList
        }
      }
    },
    searchItemWithUserInput() {
      if (this.searchByBarcode === 'Search') {
        let filteredItemList = this.displayItemList.filter(item => {
          return item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
        this.displayItemList = filteredItemList
        if (filteredItemList.length !== 0) {
          this.salesItem = filteredItemList[0]
        }
        if (this.searchTerm === '') {
          this.displayItemList = this.inMemoryList
        }
      }
      if (this.searchByBarcode === 'Code') {
        let filteredItemList = this.displayItemList.filter(item => {
          return item.itemCode.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
        this.displayItemList = filteredItemList
        if (filteredItemList.length !== 0) {
          this.salesItem = filteredItemList[0]
        }
        if (this.searchTerm === '') {
          this.displayItemList = this.inMemoryList
        }
      }
    },
    async savePOSEntry() {
      if (this.salesItemList.length === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: '',
          detail: 'No Item available!',
          life: 3000
        })
        return
      }
      if (this.contactNumber === '' || this.contactNumber === 0) {
        this.$toast.add({
          severity: 'warn',
          summary: '',
          detail: 'Please provide contact number!',
          life: 3000
        })
        return
      }
      let posItem = {
        customerName: this.customerName,
        contactNumber: this.contactNumber,
        email: this.email,
        discountAmount: this.discountAmt,
        discountPercentage: this.discountPer,
        billAmount: this.totalBillAmount,
        returningAmount: this.dueAmount,
        tenderAmount: this.tenderAmount,
        paymentMethod: this.paymentMethod,
        paymentStatus: this.paymentStatus,
        deliveryAddress: this.address,
        childSalesDetailsDTOList: this.salesItemList,
        deliveryAmount: this.deliveryCharge,
        remarks: this.remarks,
        id: this.posSalesId,
        childSalesDetailsDeletedDTOList: this.posDetailDeleteList
      }
      let response = ''
      if (!this.edit) {
        this.loading = true
        response = await this.$store.dispatch('savePOSEntry', posItem)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updatePOSEntry', posItem)
        this.$router.back()
        this.loading = false
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: response.data.message,
          life: 3000
        })
        this.reset()
        if (!this.edit) {
          this.openPrintDialog(response.data.data)
        }
      } else {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: response.data.message,
          life: 3000
        })
      }
    },
    chooseDisPercent() {
      this.chooseDiscountPer = false
      this.chooseDiscountAmt = true
      this.discountPer = 0
    },
    chooseDisountAmt() {
      this.chooseDiscountAmt = false
      this.chooseDiscountPer = true
      this.discountAmt = 0
    },
    focusOnPageLoad() {
      if (this.$store.getters.modules.includes('5.41')) {
        this.searchByBarcode = 'Barcode'
      } else {
        this.searchByBarcode = 'Search'
      }
      if (this.searchByBarcode === 'Search') {
        this.$nextTick(function () {
          this.$refs.search.$el.focus()
        })
      } else if (this.searchByBarcode === 'Barcode') {
        this.$nextTick(function () {
          this.$refs.barcode.$el.focus()
        })
      }
    },
    openPrintDialog(data) {
      this.printDialog = true
      this.dataToPrint = data
    },
    openQOTPrintDialog(data) {
      this.qotPrintDialog = true
      this.dataToPrint = data
    },
    printBill() {
      this.printDialog = false
      if (this.$store.state.organisationid === '32') {
        this.printTyp = 'qot'
      } else {
        this.printTyp = 'bill'
      }
      if (this.paymentStatus === 'UNPAID') {
        // // debugger
        this.$router.push({name: 'posDeliveryPrint', params: {printData: this.dataToPrint}})
      } else {
        this.dataToPrint.printTyp = this.printTyp
        this.$router.push({name: 'posPrintPage', params: {printData: this.dataToPrint}})
        // this.$router.push({name: 'qotPrintPage', params: { printData: this.dataToPrint }})
      }
    },
    printQOT() {
      this.printDialog = false
      this.$router.push({name: 'qotPrintPage', params: {printData: this.dataToPrint}})
    },
    checkEditRate() {
      if (this.$store.getters.modules.includes(',7.12')) {
        this.enableRateEdit = true
      }
    },
    checkSearchType() {
      if (this.$store.state.organisationid === '19') {
        this.searchByBarcode = 'Code'
      }
    },
    closePrintDialog() {
      this.printDialog = false
      this.displayItemList = this.inMemoryList
      this.itemsList()
    },
    reset() {
      this.totalQuantity = 0
      this.tenderAmount = 0
      this.subTotal = 0
      this.dueAmount = 0
      this.totalBillAmount = 0
      this.discountAmt = 0
      this.vat = 0
      this.customerName = ''
      this.contactNumber = 0
      this.email = ''
      this.salesItemList = []
      this.posDetailDeleteList = []
      this.customerName = ''
      this.contactNumber = ''
      this.address = ''
      this.deliveryCharge = 0
      this.remarks = ''
      this.searchTerm = ''
      this.checkSearchType()
    },
    editPOS() {
      this.customerName = this.pos.customerName
      this.contactNumber = this.pos.contactNumber
      this.email = this.pos.email
      this.discountAmt = this.pos.discountAmount
      this.discountPer = this.pos.discountPercentage
      this.billAmount = this.totalBillAmount
      this.returningAmount = this.dueAmount
      this.tenderAmount = this.pos.tenderAmount
      this.paymentMethod = this.pos.paymentMethod
      this.paymentStatus = this.pos.paymentStatus.toUpperCase()
      this.address = this.pos.deliveryAddress
      this.salesItemList = this.pos.childSalesDetailsDTOList
      this.deliveryCharge = this.pos.deliveryAmount
      this.remarks = this.pos.remarks
      this.posSalesId = this.pos.id
      this.edit = true
    }
  },
  components: {
    DataTable,
    Column,
    DataView,
    Card,
    Button,
    InputText,
    RadioButton,
    InputNumber,
    InputMask,
    Dialog
  }
}
</script>
<!-- <style scoped>
.product-category {
  font-weight: 600;
  vertical-align: middle;
}

.product-grid-item {
  margin: .5rem;
  border: 1px solid #dee2e6;
}

.layout-content .card {
  background: var(--surface-e);
  padding: 2rem;
  -webkit-box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  border-radius: 4px;
  margin-bottom: 2rem;
}

.product-grid-item .product-grid-item-content {
  text-align: center;
}

.product-name {
  font-size: 1.2rem;
  font-weight: 700;
}

.product-description {
  margin: 0 0 1rem 0;
}

.product-grid-item .product-price {
  font-size: 1.2rem;
  font-weight: 600;
}

.product-grid-item img {
  /* width: 75%; */
  -webkit-box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
  margin: 2rem 0;
}

.p-datatable .p-datatable-tbody > tr > td.p-cell-editing .p-component {
  width: -1% !important
}
</style> -->



// WEBPACK FOOTER //
// posEntry.vue?83eb2328